import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  Snackbar,
  Alert,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from "@mui/material";
import axios from "axios";
import { API_URL } from "../../../Config/api";

function StepOnePersonalInfo({
  formData,
  setFormData,
  errors,
  handleChange,
  handleDropdownService,
  selectedService,
}) {
  // const port = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem("token");
  const [service, setService] = useState([]);
  const [city, setCity] = useState([]);
  const [bloodGroups, setBloodGroups] = useState([]);
  const [allergies, setAllergies] = useState([]);
  const [state, setState] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  useEffect(() => {
    const getService = async () => {
      try {
        const res = await fetch(`${API_URL}/web/agg_hhc_services_api_web_form`, {
          headers: {
            // Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();

        setService(data);
      } catch (error) {
        console.error("Error fetching service data:", error);
      }
    };
    getService();
  }, []);

  useEffect(() => {
    const getCity = async () => {
      if (!selectedState) return;
      try {
        const res = await fetch(
          `${API_URL}/web/agg_hhc_city_api/${selectedState}`,
          {
            headers: {
              // Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await res.json();
        setCity(data);

        let defaultCityId = null;

        if (formData?.city_id) {
          const exists = data.find((c) => c.city_id === formData.city_id);
          if (exists) defaultCityId = formData.city_id;
        }

        if (!defaultCityId && data.length > 0) {
          defaultCityId = data[0].city_id;
        }

        if (defaultCityId) {
          setSelectedCity(defaultCityId);
          setFormData((prev) => ({
            ...prev,
            city_id: defaultCityId,
          }));
        }
      } catch (error) {
        console.error("Error fetching city data:", error);
      }
    };
    getCity();
  }, [selectedState, formData.city_id]);

  useEffect(() => {
    fetch(`${API_URL}/web/blood_group/`, {
      method: "GET",
      headers: {
        // Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Blood Groups:", data);
        setBloodGroups(data);
      })
      .catch((err) => console.error("Blood Group API Error:", err));
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/web/Allergies/`, {
        headers: {
          // Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((res) => {
        setAllergies(res.data || []);
      })
      .catch((err) => {
        console.error("Error fetching allergies:", err);
      });
  }, []);

  useEffect(() => {
    const getState = async () => {
      try {
        const res = await fetch(`${API_URL}/web/agg_hhc_state_api`, {
          headers: {
            // Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        });
        const data = await res.json();
        console.log("State List....", data);
        setState(data);
      } catch (error) {
        console.error("Error fetching State data:", error);
      }
    };
    getState();
  }, []);

  useEffect(() => {
    if (Array.isArray(state) && state.length > 0 && !selectedState) {
      const defaultState = state.find((s) => s.state_name === "Maharashtra");
      if (defaultState) {
        setSelectedState(defaultState.state_id);
        handleChange("state_id", defaultState.state_id);
      } else {
        setSelectedState(state[0].state_id);
        handleChange("state_id", state[0].state_id);
      }
    }
  }, [state]);

 const handleMedicalHistoryChange = (id, checked) => {
  setFormData((prev) => {
    const prevHistory = prev.past_medical_history || [];

    const updatedHistory = checked
      ? [...prevHistory, id]
      : prevHistory.filter((item) => item !== id);

    return {
      ...prev,
      past_medical_history: updatedHistory,
      // 👇 Other unchecked → text clear
      other_past_medical_history:
        id === 9 && !checked ? "" : prev.other_past_medical_history,
    };
  });
};


const calculateAgeDetails = (dob) => {
  if (!dob) return null;

  const birthDate = new Date(dob);
  const today = new Date(); // ✅ CURRENT DATE

  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();

  if (days < 0) {
    months--;
    const prevMonthDays = new Date(
      today.getFullYear(),
      today.getMonth(),
      0
    ).getDate();
    days += prevMonthDays;
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  return { years, months, days };
};

useEffect(() => {
  if (!formData.dob) return;

  const ageData = calculateAgeDetails(formData.dob);

  setFormData((prev) => ({
    ...prev,                
    Age: ageData.years,
    Age_month: ageData.months,
    Age_day: ageData.days,
  }));
}, [formData.dob]);


const ageDisplay =
  formData.Age   !== undefined
    ? `${formData.Age} Years ${formData.Age_month || 0} Months ${formData.Age_day || 0} Days`
    : "";


  return (
    <>
      <Box>
        {/* Snackbar */}

        {/* Personal Info Card */}
        <Card
          variant="outlined"
          sx={{
            mb: 2,
            borderRadius: 3,
            boxShadow: 3,
            backgroundColor: "#fafafa",
            height: "100%",
          }}
        >
          <CardContent>
            <Typography
              gutterBottom
              color="primary"
              sx={{
                fontWeight: "600",
                fontSize: "1rem",
                mb: 2,
              }}
            >
              PERSONAL INFORMATION
            </Typography>

            <Grid container spacing={2}>
              {/* Name */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Name"
                  fullWidth
                  size="small"
                  value={formData.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                  error={!!errors.name}
                  helperText={errors.name}
                />
              </Grid>

              {/* Patient Number */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Patient Number"
                  size="small"
                  fullWidth
                  value={formData.phone_no || ""}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    if (value.length > 10) value = value.slice(0, 10);
                    handleChange("phone_no", value);
                  }}
                  error={!!errors.phone_no}
                  helperText={errors.phone_no}
                  inputProps={{
                    maxLength: 10,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                />
              </Grid>

              {/* Caller Number */}
              {/* <Grid item xs={12} sm={3}>
                <TextField
                  label="Caller Number"
                  size="small"
                  fullWidth
                  value={formData.callerPhone || ""}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    if (value.length > 10) value = value.slice(0, 10);
                    handleChange("callerPhone", value);
                  }}
                  error={!!errors.callerPhone}
                  helperText={errors.callerPhone}
                  inputProps={{ maxLength: 10 }}
                />
              </Grid> */}

              {/* DOB */}
    <Grid item xs={12} sm={3}>
  <TextField
    type="date"
    label="DOB"
    fullWidth
    size="small"
    value={formData.dob}
        error={Boolean(errors.dob)}
    helperText={errors.dob}
    onChange={(e) => handleChange("dob", e.target.value)}
    InputLabelProps={{ shrink: true }}
    inputProps={{
      max: new Date().toISOString().split("T")[0], // 👈 future date disable
    }}
  />
</Grid>

              {/* Gender */}
              <Grid item xs={12} sm={3}>
                <FormControl fullWidth size="small" error={!!errors.gender_id}>
                  <InputLabel>Gender</InputLabel>
                  <Select
                    value={formData.gender_id || ""}
                    label="Gender"
                    onChange={(e) => handleChange("gender_id", e.target.value)}
                  >
                    <MenuItem value="1">Male</MenuItem>
                    <MenuItem value="2">Female</MenuItem>
                  </Select>
                  {errors.gender_id && (
                    <Typography variant="caption" color="error">
                      {errors.gender_id}
                    </Typography>
                  )}
                </FormControl>
              </Grid>

              {/* Marital Status */}
              <Grid item xs={12} sm={3}>
                <FormControl
                  fullWidth
                  size="small"
                  error={!!errors.marital_status}
                >
                  <InputLabel>Marital Status</InputLabel>
                  <Select
                    value={formData.marital_status || ""}
                    label="Marital Status"
                    onChange={(e) =>
                      handleChange("marital_status", e.target.value)
                    }
                  >
                    <MenuItem value={1}>Single</MenuItem>
                    <MenuItem value={2}>Married</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {/* Service Dropdown */}
              {/* <Grid item xs={12} sm={3}>
                <TextField
                  label="Select Service"
                  select
                  fullWidth
                  size="small"
                  value={selectedService}
                  onChange={handleDropdownService}
                >
                  {service.map((option) => (
                    <MenuItem key={option.srv_id} value={option.srv_id}>
                      {option.service_title}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid> */}

              {/* Identification mark */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Identification Mark"
                  fullWidth
                  size="small"
                  value={formData.identification_mark || ""}
                  onChange={(e) =>
                    handleChange("identification_mark", e.target.value)
                  }
                  error={!!errors.identification_mark}
                  helperText={errors.identification_mark}
                />
              </Grid>

              {/* State */}
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="State"
                  fullWidth
                  size="small"
                  value={selectedState || ""}
                  onChange={(e) => handleChange("state_id", e.target.value)}
                  error={!!errors.state_id} // errors.state_id se match karein
                  helperText={errors.state_id}
                >
                  {state && state.length > 0 ? (
                    state.map((s) => (
                      <MenuItem key={s.state_id} value={s.state_id}>
                        {s.state_name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>Loading...</MenuItem>
                  )}
                </TextField>
              </Grid>

              {/* City */}
              <Grid item xs={12} sm={3}>
                <TextField
                  select
                  label="City"
                  fullWidth
                  size="small"
                  value={selectedCity}
                  onChange={(e) => {
                    const selected = city.find(
                      (c) => c.city_id === e.target.value
                    );
                    setSelectedCity(e.target.value);
                    setFormData((prev) => ({
                      ...prev,
                      patientDetails: {
                        ...prev.patientDetails,
                        city: selected?.city_name || "",
                      },
                    }));
                  }}
                >
                  {city.map((c) => (
                    <MenuItem key={c.city_id} value={c.city_id}>
                      {c.city_name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Address */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Address"
                  fullWidth
                  size="small"
                  value={formData.address}
                  onChange={(e) => handleChange("address", e.target.value)}
                  error={!!errors.address}
                  helperText={errors.address}
                />
              </Grid>

              {/* Pincode */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Pincode"
                  fullWidth
                  size="small"
                  value={formData.pincode}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    if (value.length > 6) value = value.slice(0, 6);
                    handleChange("pincode", value);
                  }}
                  error={!!errors.pincode}
                  helperText={errors.pincode}
                />
              </Grid>

              {/* Allergies */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Allergies"
                  fullWidth
                  size="small"
                  value={formData.allergies || ""}
                  onChange={(e) => handleChange("allergies", e.target.value)}
                  error={!!errors.allergies}
                  helperText={errors.allergies}
                />
              </Grid>

              {/* Vaccinations */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Vaccinations"
                  fullWidth
                  size="small"
                  value={formData.vaccinations || ""}
                  onChange={(e) => handleChange("vaccinations", e.target.value)}
                  error={!!errors.vaccinations}
                  helperText={errors.vaccinations}
                />
              </Grid>

              {/* Attendant Name */}
              {/* <Grid item xs={12} sm={3}>
                <TextField
                  label="Attendant Name"
                  fullWidth
                  size="small"
                  value={formData.attendantName}
                  onChange={(e) =>
                    handleChange("attendantName", e.target.value)
                  }
                  error={!!errors.attendantName}
                  helperText={errors.attendantName}
                />
              </Grid> */}

              {/* Family Doctor */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Family Doctor"
                  fullWidth
                  size="small"
                  value={formData.family_doctor}
                  onChange={(e) =>
                    handleChange("family_doctor", e.target.value)
                  }
                  error={!!errors.family_doctor}
                  helperText={errors.family_doctor}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Family Doctor Phone"
                  fullWidth
                  size="small"
                  value={formData.family_doctor_phone || ""}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, ""); // remove non-numbers
                    if (value.length <= 10) {
                      handleChange("family_doctor_phone", value);
                    }
                  }}
                  error={!!errors.family_doctor_phone}
                  helperText={errors.family_doctor_phone}
                  inputProps={{
                    maxLength: 10,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Family Doctor Email"
                  fullWidth
                  size="small"
                  value={formData.family_doctor_email}
                  onChange={(e) =>
                    handleChange("family_doctor_email", e.target.value)
                  }
                  error={!!errors.family_doctor_email}
                  helperText={errors.family_doctor_email}
                />
              </Grid>

              {/* Height */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Height (cm)"
                  fullWidth
                  size="small"
                  value={formData.height}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    if (value.length > 3) value = value.slice(0, 2);
                    handleChange("height", value);
                  }}
                  error={!!errors.height}
                  helperText={errors.height}
                />
              </Grid>

              {/* Weight */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Weight (kg)"
                  fullWidth
                  size="small"
                  value={formData.weight}
                  onChange={(e) => {
                    let value = e.target.value.replace(/\D/g, "");
                    if (value.length > 3) value = value.slice(0, 2);
                    handleChange("weight", value);
                  }}
                  error={!!errors.weight}
                  helperText={errors.weight}
                />
              </Grid>

              {/* Age */}
<Grid item xs={12} sm={3}>
  <TextField
    label="Age"
    fullWidth
    size="small"
    value={ageDisplay}
    InputProps={{
      readOnly: true,
    }}
  />
</Grid>

              {/* Blood Group */}
             <Grid item xs={12} sm={3}>
  <FormControl
    fullWidth
    size="small"
    error={!!errors.blood_group} // 🔑 error yahin lagta hai
  >
    <InputLabel id="blood-group-label">
      Blood Group
    </InputLabel>

    <Select
      labelId="blood-group-label"
      label="Blood Group"
      value={formData.blood_group || ""}
      onChange={(e) =>
        handleChange("blood_group", e.target.value)
      }
    >
      {bloodGroups.map((bg) => (
        <MenuItem
          key={bg.blood_group_id}
          value={bg.blood_group_id}
        >
          {bg.blood_group_name}
        </MenuItem>
      ))}
    </Select>

    {/* ✅ Error text yahan aayega */}
    {errors.blood_group && (
      <FormHelperText>
        {errors.blood_group}
      </FormHelperText>
    )}
  </FormControl>
</Grid>

              {/* Next of Kin */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Next of Kin / Spouse Name"
                  fullWidth
                  size="small"
                  value={formData?.spouse_name || ""}
                  onChange={(e) => handleChange("spouse_name", e.target.value)}
                  error={!!errors.spouse_name}
                  helperText={errors.spouse_name}
                />
              </Grid>

              {/* Next of Kin Phone */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Next of Kin Phone"
                  fullWidth
                  size="small"
                  value={formData.spouse_phone || ""}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    if (value.length <= 10) {
                      handleChange("spouse_phone", value);
                    }
                  }}
                  error={!!errors.spouse_phone}
                  helperText={errors.spouse_phone}
                  inputProps={{
                    maxLength: 10,
                    inputMode: "numeric",
                  }}
                />
              </Grid>

              {/* Next of Kin Email */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Next of Kin Email"
                  fullWidth
                  size="small"
                  value={formData.spouse_email || ""}
                  onChange={(e) => handleChange("spouse_email", e.target.value)}
                  error={!!errors.spouse_email}
                  helperText={errors.spouse_email}
                />
              </Grid>

              {/* Insurance */}
              <Grid item xs={12} sm={3}>
                <TextField
                  label="Insurance Provider"
                  fullWidth
                  size="small"
                  value={formData.insurance || ""}
                  onChange={(e) => handleChange("insurance", e.target.value)}
                  error={!!errors.insurance}
                  helperText={errors.insurance}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        {/* SOCIAL HABITS */}
        <Grid item xs={12}>
          <Card
            sx={{
              mb: 2,
              borderRadius: 3,
              boxShadow: 3,
              backgroundColor: "#fafafa",
            }}
          >
            <CardContent>
              <Typography
                color="primary"
                sx={{ fontWeight: 600, fontSize: "1rem", mb: 2 }}
              >
                SOCIAL HABITS
              </Typography>

              <Grid container spacing={2}>
                {/* Tobacco */}
                {/* Tobacco */}
                <Grid item xs={12} sm={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Tobacco</InputLabel>
                    <Select
                      label="Tobacco"
                      value={formData.tobacco ?? false} 
                      onChange={(e) => handleChange("tobacco", e.target.value)}
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Tobacco Notes */}
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Tobacco Notes"
                    fullWidth
                    size="small"
                    disabled={!formData.tobacco} 
                    value={formData.tobacco_remark || ""}
                    onChange={(e) =>
                      handleChange("tobacco_remark", e.target.value)
                    }
                    error={!!errors.tobacco_remark}
                    helperText={errors.tobacco_remark}
                  />
                </Grid>

                {/* Alcohol */}
                <Grid item xs={12} sm={3}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Alcohol</InputLabel>
                    <Select
                      label="Alcohol"
                      value={formData.alcohol ?? false} 
                      onChange={(e) => handleChange("alcohol", e.target.value)}
                    >
                      <MenuItem value={true}>Yes</MenuItem>
                      <MenuItem value={false}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {/* Alcohol Notes */}
                <Grid item xs={12} sm={3}>
                  <TextField
                    label="Alcohol Notes"
                    fullWidth
                    size="small"
                    disabled={!formData.alcohol} 
                    value={formData.alcohol_remark || ""}
                    onChange={(e) =>
                      handleChange("alcohol_remark", e.target.value)
                    }
                    error={!!errors.alcohol_remark}
                    helperText={errors.alcohol_remark}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        {/* PAST MEDICAL HISTORY */}
    <Grid item xs={12}>
  <Card
    sx={{
      mb: 2,
      borderRadius: 3,
      boxShadow: 3,
      backgroundColor: "#fafafa",
      border: errors.past_medical_history
        ? "1px solid #d32f2f"
        : "1px solid transparent",
    }}
  >
    <CardContent>
      {/* TITLE */}
      <Typography
       color="primary"
                sx={{ fontWeight: 600, fontSize: "1rem", mb: 2 }}
      
      >
        PAST MEDICAL HISTORY
      </Typography>

      {/* ERROR MESSAGE */}
      {errors.past_medical_history && (
        <Typography
          variant="caption"
          color="error"
          sx={{ mb: 1, display: "block", textAlign: "center" }}
        >
          {errors.past_medical_history}
        </Typography>
      )}

      <FormGroup>
        <Grid container spacing={1.5}>
          {/* MEDICAL HISTORY CHECKBOXES */}
          {allergies.map((item) => {
            const key = `medical_${item.medical_id}`;

            return (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}     // ✅ perfect 3 columns on desktop
                key={key}
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <FormControlLabel
                  sx={{
                    m: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    ".MuiCheckbox-root": {
                      p: 0.5,
                    },
                    ".MuiFormControlLabel-label": {
                      fontSize: "0.85rem",
                      lineHeight: 1.2,
                      whiteSpace: "normal",
                    },
                  }}
                  control={
                   <Checkbox
  size="small"
  checked={
    formData.past_medical_history?.includes(item.medical_id) || false
  }
  onChange={(e) =>
    handleMedicalHistoryChange(
      item.medical_id,
      e.target.checked
    )
  }
/>
                  }
                  label={item.Allergies.trim()}
                />
              </Grid>
            );
          })}

          {/* OTHER OPTION */}
      

          {/* OTHER NOTES */}
         {formData.past_medical_history?.includes(9) && (
  <Grid item xs={12}>
    <TextField
      label="Other Medical History Notes"
      fullWidth
      size="small"
      multiline
      minRows={2}
      value={formData.other_past_medical_history || ""}
      onChange={(e) =>
        handleChange(
          "other_past_medical_history",
          e.target.value
        )
      }
      error={!!errors.other_past_medical_history}
      helperText={errors.other_past_medical_history}
    />
  </Grid>
)}
        </Grid>
      </FormGroup>
    </CardContent>
  </Card>
</Grid>


      </Box>
    </>
  );
}

export default StepOnePersonalInfo;
